export enum SupportEmail {
  NURSING_HOME = 'support@pflegenavi.at',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  SERVICE_PROVIDER = 'support@pflegenavi.at',
  FAMILY_MEMBER = 'help@pflegenavi.at',
}
